module.exports = __webpack_public_path__ + "assets/img/34-m.584c9d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/34-m.jpg
// module id = flvd
// module chunks = 0